import React from 'react';
import { Avatar, Dropdown, Menu, Button } from '@oscar/theme';
import { useAuth, ROLES_NAME } from '../../config';
import './style.scss';

const Profile: React.FC = () => {
  const [auth] = useAuth();

  const menu = (
    <Menu className="profile-items">
      <Menu.Item>
        <div className="profile-item">
          <Avatar className="profile-item-avatar" size={40}>
            {auth.getUserInformation()?.shortName}
          </Avatar>
          <div className="profile-item-name">
            {auth.getUserInformation()?.fullName}
          </div>
          <div className="profile-item-role">
            {`(${auth
              .getValidRoles()
              .map(item => ROLES_NAME[item])
              .join(', ')})`}
          </div>
          <Button
            onClick={() => {
              auth.logout();
            }}
            className="profile-item-button"
          >
            Sign Out
          </Button>
        </div>
      </Menu.Item>
    </Menu>
  );

  return (
    <div className="profile">
      <Dropdown trigger={['click']} overlay={menu} placement="bottomRight">
        <Avatar className="profile-avatar" size={40}>
          {auth.getUserInformation()?.shortName}
        </Avatar>
      </Dropdown>
    </div>
  );
};

export default Profile;
